import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { SnackBarService } from "@core/services/snack-bar.service";
import { TimeZoneService } from "@core/services/time-zone.service";
import { ChangeReportFilterModel } from "@features/change-report/models/change-report.model";
import { IDialogView } from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import { DialogModel } from "@shared/models/dialog.model";

@Component({
    standalone: false,
    selector: "app-date-range-dialog-component",
  templateUrl: "./date-range-dialog-component.component.html",
  styleUrls: ["./date-range-dialog-component.component.scss"],
})
export class DateRangeDialogComponentComponent
  implements OnInit, IDialogView, OnDestroy
{
  changeReportFilter: ChangeReportFilterModel;
  fromDate: Date;
  toDate: Date;
  data: DialogModel;

  constructor(
    private timeZoneService: TimeZoneService,
    private snackBarService: SnackBarService
  ) {}
  ngOnDestroy(): void {
    return;
  }
  onOkClicked(): boolean {
    if (this.checkValidDateRange()) {
      this.data.input.dateFilter.fromDate = this.fromDate;
      this.data.input.dateFilter.fromDateValue =
        this.timeZoneService.getDisplayDate(this.fromDate);
      this.data.input.dateFilter.toDate = this.toDate;
      this.data.input.dateFilter.toDateValue =
        this.timeZoneService.getDisplayDate(this.toDate);
      return true;
    } else {
      this.snackBarService.showError("Invalid Date Range");
    }
    return false;
  }

  checkValidDateRange() {
    if (this.fromDate > this.toDate) {
      return false;
    }
    return true;
  }

  ngOnInit(): void {
    this.fromDate = this.timeZoneService.getDisplayDate(
      this.data.input.dateFilter.fromDate
    );
    this.toDate = this.timeZoneService.getDisplayDate(
      this.data.input.dateFilter.toDate
    );
  }

  onFromDateChange(type: string, event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.fromDate = this.timeZoneService.getDisplayDate(this.timeZoneService.getUTCDateWithZeroTimeOffset(event.value));
    }
  }

  onToDateChange(type: string, event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.toDate = this.timeZoneService.getDisplayDate(this.timeZoneService.getUTCDateWithZeroTimeOffset(event.value));
    }
  }

}
